import React from 'react'
const AnalyticsPage: React.FC = () => (
  <div className="space-y-6">
    <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>
    <div className="card"><div className="card-body text-center py-12"><p className="text-gray-600">Advanced analytics coming soon...</p></div></div>
  </div>
)
export default AnalyticsPage